(() => {
  const FORMS_ROOT_ID = 'forms-root-605686';
  const FIELD_ID = 'custom#machine_url';

  const findFieldInOpenShadows = (shadow, id) => {
    const direct = shadow.getElementById(id);
    if (direct) return direct;

    for (const host of shadow.querySelectorAll('*')) {
      if (!host.shadowRoot) continue;
      const found = findFieldInOpenShadows(host.shadowRoot, id);
      if (found) return found;
    }

    return null;
  };

  const HIDE_STYLE_MARKER = 'data-nf-hide-machine-url';

  const injectHideStylesOnce = (shadowRoot) => {
    if (!(shadowRoot instanceof ShadowRoot)) return;
    if (shadowRoot.querySelector(`style[${HIDE_STYLE_MARKER}]`)) return;

    const style = document.createElement('style');
    style.setAttribute(HIDE_STYLE_MARKER, '');
    style.textContent = `
[id="${FIELD_ID}"],
label[for="${FIELD_ID}"],
label:has([id="${FIELD_ID}"]),
*:has(+ [id="${FIELD_ID}"]) {
  display: none !important;
}
`.trim();

    shadowRoot.appendChild(style);
  };

  const hideMachineUrlLabelChrome = (field) => {
    const root = field.getRootNode();

    if (field.labels) {
      for (const label of field.labels) {
        label.style.setProperty('display', 'none', 'important');
      }
    }

    const labelledBy = field.getAttribute('aria-labelledby');
    if (labelledBy && root instanceof ShadowRoot) {
      for (const rawId of labelledBy.trim().split(/\s+/)) {
        const id = rawId.trim();
        if (!id) continue;
        const el = root.getElementById(id);
        if (el) el.style.setProperty('display', 'none', 'important');
      }
    }

    let prev = field.previousElementSibling;
    for (let i = 0; i < 6 && prev; i++) {
      prev.style.setProperty('display', 'none', 'important');
      prev = prev.previousElementSibling;
    }

    let node = field;
    for (let depth = 0; depth < 8 && node; depth++) {
      const parent = node.parentElement;
      if (!parent) break;

      const siblings = [...parent.children];
      const idx = siblings.indexOf(node);
      if (idx > 0) {
        for (let i = 0; i < idx; i++) {
          siblings[i].style.setProperty('display', 'none', 'important');
        }
        break;
      }

      node = parent;
    }
  };

  const ensureMachineUrlFieldHidden = (field) => {
    const root = field.getRootNode();
    if (!(root instanceof ShadowRoot)) return;

    injectHideStylesOnce(root);
    hideMachineUrlLabelChrome(field);
  };

  const collectTargetEmbeds = () => {
    const embeds = [];
    const roots = document.querySelectorAll(`[data-forms-id="${FORMS_ROOT_ID}"]`);

    for (const root of roots) {
      for (const el of root.querySelectorAll('shopify-forms-embed, form-embed')) {
        embeds.push(el);
      }
    }

    if (embeds.length > 0) return embeds;

    for (const el of document.querySelectorAll('shopify-forms-embed, form-embed')) {
      if (el.closest(`[data-forms-id="${FORMS_ROOT_ID}"]`)) embeds.push(el);
    }

    return embeds;
  };

  const fillMachineUrlFields = () => {
    const href = window.location.href;

    for (const embed of collectTargetEmbeds()) {
      const shadow = embed.shadowRoot;
      if (!shadow) continue;

      const field = findFieldInOpenShadows(shadow, FIELD_ID);
      if (!field) continue;

      ensureMachineUrlFieldHidden(field);

      if (field.value === href) continue;

      field.value = href;
      field.setAttribute('value', href);
      field.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
      field.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
    }
  };

  let pending = false;

  const scheduleFill = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      fillMachineUrlFields();
    });
  };

  fillMachineUrlFields();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fillMachineUrlFields);
  }

  const observer = new MutationObserver(scheduleFill);
  observer.observe(document.body, { childList: true, subtree: true });
})();
